module.exports = __webpack_public_path__ + "effb8ffd6b53d3e5c7c7a38385393867.ttf";